export const fieldInfoTranslations = {
  sortingWeight: [
    'Durch die Sortierung kann die Reihenfolge der Produkte bei der Buchungsübersicht innerhalb einer Kategorie angepasst werden. Produkte werden aufsteigend anhand dieser Nummer sortiert',
    'By giving a custom sorting weight, the order of the products on the registration overview inside a category can be customized. Products are sorted by the sorting weight ascending.',
  ],
  institution: {
    name: [
      'Name der Institution. Dieser wird in der Übersicht aller Institutionen verwendet.',
      'Name of the institution. This is used in the overview of all institutions.',
    ],
    shortDescription: [
      'Dieses Feld bietet eine kurze Zusammenfassung oder Beschreibung der Institution.',
      'This field provides a brief summary or description of the institution.',
    ],
    ccMail: [
      'Die hier angegebene E-Mail wird in allen Institutions E-Mail als Cc verwendet',
      'This E-Mail gets used as Cc for all institution mails',
    ],
    noAccountNeeded: [
      'Durch Ankreuzen dieses Kästchens wird angezeigt, dass Benutzer kein Konto auf dieser Plattform erstellen müssen, um auf ihre Funktionen zugreifen zu können. Visuell findet kein Login statt.',
      'Checking this box indicates that users are not required to create an account on this platform to access its features.',
    ],
    ldapNeeded: [
      'Dieses Feld gibt an, dass Benutzer einen LDAP (Lightweight Directory Access Protocol)-Account benötigen, um auf das System zuzugreifen.',
      'This field indicates that users are required to have an LDAP (Lightweight Directory Access Protocol) account to access the system.',
    ],
    sortByDate: [
      'Diese Funktion ermöglicht es Ihnen, Termine in der Anmeldungsverwaltung basierend auf ihren jeweiligen Datum zu organisieren.',
      'This feature allows you to organize appointments in the registration system based on their respective dates.',
    ],
    ccAdress: [
      'Die CC-Bestätigungsadresse bezieht sich auf die E-Mail-Adresse, an die eine Kopie (CC) der Bestätigung gesendet wird, zusätzlich zum Hauptempfänger.',
      'The CC Confirmation Address refers to the email address where a copy (CC) of the confirmation will be sent in addition to the primary recipient.',
    ],
    senderAdress: [
      'Die Absender-Adresse repräsentiert die E-Mail-Adresse oder Kontaktdaten, von denen aus Mitteilungen oder Benachrichtigungen versendet werden.',
      'The Sender Address represents the email address or contact details from which communications or notifications are sent.',
    ],
    contactAdress: [
      'Die Kontakt-E-Mail ist die festgelegte E-Mail-Adresse, an die Benutzer sich bei Anfragen, Unterstützungsanfragen oder allgemeiner Kommunikation wenden können.',
      'The Contact Email is the designated email address where users can reach out for inquiries, support, or general communication.',
    ],
    emailSignature: [
      'Das Textfeld ermöglicht es Ihnen, einen personalisierten Textblock oder Informationen einzugeben, der automatisch am Ende Ihrer E-Mails angehängt wird.',
      'The Email Signature allows you to enter a personalized block of text or information that will be automatically appended to the end of your emails.',
    ],
    cancellationDeadline: [
      'Wenn die Abmeldefrist beispielsweise auf 3 Tage festgelegt ist, besteht die Möglichkeit, sich bis zu 3 Tage vor Beginn des Termins abzumelden.',
      'For instance, if the cancellation deadline is set to 3 days, you can withdraw your registration up to 3 days before the commencement of the appointment.',
    ],
    cancellationDeadlineDateInfo: ['Abmeldung nicht mehr möglich ab:', 'Participants cannot cancel from:'],
    waitinglistDeadline: [
      'Gibt an, ab wievielen Tagen vor Start des Termins die Warteliste nichtmehr automatisch vorrückt.',
      'Specifies how many days before the start of the appointment the queue will no longer advance automatically.',
    ],
    waitingListDeadlineDateInfo: [
      'Automatisches Nachrücken nicht mehr aktiv ab:',
      'Automatic waiting list updates will not be performed from:',
    ],
    firstReminderMail: [
      'Gibt an, wie viele Tage vor Start der Veranstaltung die erste Erinnerungsmail versendet werden soll.',
      'Specifies how many days before the start of the event the first reminder email should be sent.',
    ],
    firstReminderMailDateInfo: [
      'Die 1. Erinnerungsmail für die Veranstaltung wird versandt am:',
      'The first reminder mails will each be scheduled at:',
    ],
    secondReminderMail: [
      'Gibt an, wie viele Tage vor Start der Veranstaltung die zweite Erinnerungsmail versendet werden soll.',
      'Specifies how many days before the start of the event the second reminder email should be sent.',
    ],
    secondReminderMailDateInfo: [
      'Die 2. Erinnerungsmail für die Veranstaltung wird versandt am:',
      'The second reminder mails will each be scheduled at:',
    ],
    firstAppointmentReminderMail: [
      'Gibt an, wieviele Tage vor Start jedes Termins die erste Termin-Erinnerungsmail versendet werden soll.',
      'Specifies how many days before the start of the appointment the first appointment reminder email should be sent.',
    ],
    firstAppointmentReminderMailDateInfo: [
      'Die 1. Termin-Erinnerungsmail wird versandt am:',
      'The first appointment reminder mail will be sent on:',
    ],
    secondAppointmentReminderMail: [
      'Gibt an, wieviele Tage vor Start jedes Termins die zweite Termin-Erinnerungsmail versendet werden soll.',
      'Specifies how many days before the start of the appointment the second appointment reminder email should be sent.',
    ],
    secondAppointmentReminderMailDateInfo: [
      'Die 2. Termin-Erinnerungsmail wird versandt am:',
      'The second appointment reminder mail will be sent on:',
    ],
    meetingInfoMailLeadTime: [
      'Gibt an wie viele Tage vor Beginn die genauen Informationen zum Termin versendet werden.',
      'Specifies how many days before the start the exact information about the appointment will be sent.',
    ],
    maxSimultaneousRegistrations: [
      'Die maximale gleichzeitige Anmeldungen repräsentiert die höchste Anzahl von aktiven Anmeldungen die ein Nutzer haben darf.',
      'The maximum concurrent logins represents the highest number of active logins a user is allowed to have.',
    ],
    internAccountingEmail: [
      'Die internen Rechnungskopien werden an diese E-Mail Adresse gesendet.',
      'The internal accounting copies are sent to this email address.',
    ],
    sendInvoiceDaysInAdvance: [
      'Gebe an wie viele Tage vor Workshop Beginn die Rechnungsmail gesendet werden soll.',
      'Set how many days prior to workshop start the invoice should get sent',
    ],
    sendInvoiceDaysInAdvanceDateInfo: ['Die Rechnungen werden versandt am', 'Invoices will be sent on'],
    replyToMailAddress: [
      'Die Antwortadresse ist die E-Mail-Adresse, an die Benutzer antworten können, wenn sie auf eine E-Mail antworten, die von dieser Institution gesendet wurde.',
      'The reply address is the email address where users can reply when responding to an email sent by this institution.',
    ],
  },
  certificate: {
    description: [
      'Innerhalb der Datei können Sie Variablen wie {Produkt_Titel}, {Produkt_Beschreibung} und {Termine_Datum_Uhrzeit} verwenden. Das System füllt automatisch diese Platzhalter mit den entsprechenden Daten aus. Dies erleichtert die personalisierte Anpassung von Dokumenten',
      'Within the file, you can use variables such as {Produkt_Titel}, {Produkt_Beschreibung}, and {Termine_Datum_Uhrzeit}. The system automatically fills in these placeholders with the corresponding data. This makes it easier to personalize documents',
    ],
  },
  contract: {
    description: [
      'Innerhalb der Datei können Sie Variablen wie {Dozent_Name}, {Produkt_Titel}, und {Vertrags_Datum} verwenden. Das System füllt automatisch diese Platzhalter mit den entsprechenden Daten aus. Dies erleichtert die personalisierte Anpassung von Verträgen.',
      'Within the file, you can use variables such as {Dozent_Name}, {Produkt_Titel}, and {Vertrags_Datum}. The system automatically fills in these placeholders with the corresponding data. This makes it easier to personalize contracts.',
    ],
  },
};
